import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React from "react";

import { Box, Flex, Text } from "~/components/blocks";
import { publicPath } from "~/utils/path";

const Root = styled("div")(({ theme }) =>
  css({
    border: `1px dashed ${theme.colors.colorPallete.green}`,
    borderRadius: theme.radii.default,
    marginTop: theme.space.xxl,
    position: "relative",
    padding: `${theme.space.xxl} ${theme.space.l} ${theme.space.l}`,
  }),
);

const Title = styled("div")(({ theme }) =>
  css({
    background: theme.colors.background.primary,
    borderRadius: "100px",
    color: theme.colors.text.white,
    fontWeight: theme.fontWeights.bold,
    left: "50%",
    textAlign: "center",
    top: "-20px",
    transform: "translateX(-50%)",
    padding: theme.space.m,
    position: "absolute",
    width: "95%",
  }),
);

const FlowBox = styled(Box)(({ theme }) =>
  css({
    display: "flex",
    justifyContent: "space-evenly",
    [`@media ${theme.mediaQueries.sp}`]: {
      display: "block",
    },
  }),
);

const Step = styled(Flex)(({ theme }) =>
  css({
    alignItems: "center",
    display: "block",
    position: "relative",
    width: "33.3%",
    paddingLeft: theme.space.l,
    paddingRight: theme.space.l,
    [`@media ${theme.mediaQueries.sp}`]: {
      width: "inherit",
      display: "flex",
    },
  }),
);

const Description = styled(Box)(({ theme }) =>
  css({
    [`@media ${theme.mediaQueries.sp}`]: {
      marginLeft: theme.space.l,
    },
  }),
);

const Illustration = styled("img")(({ theme }) =>
  css({
    borderRadius: theme.radii.half,
    height: "120px",
    margin: `${theme.space.l} ${theme.space.m}`,
    width: "120px",
    [`@media ${theme.mediaQueries.sp}`]: {
      marginLeft: "0",
    },
  }),
);

export const NextFlow = () => {
  return (
    <Root>
      <Title>このあとの流れ</Title>
      <FlowBox>
        <Step>
          <Illustration src={publicPath("/images/img-after-flow01.svg")} />
          <Description>
            <Text fontWeight="bold" color="green">
              1.調剤
            </Text>
            <Text block fontWeight="bold" size="s" mb="m">
              薬局がお薬の準備をはじめます
            </Text>
          </Description>
        </Step>
        <Step>
          <Illustration src={publicPath("/images/img-after-flow02.svg")} />
          <Description>
            <Text fontWeight="bold" color="green">
              2.スマホに通知
            </Text>
            <Text block fontWeight="bold" size="s" mb="m">
              お薬の準備が完了したら、あなたのスマホに通知でお知らせします
            </Text>
          </Description>
        </Step>
        <Step>
          <Illustration src={publicPath("/images/img-after-flow03.svg")} />
          <Description>
            <Text fontWeight="bold" color="green" mb="m">
              3.お薬のお渡し
            </Text>
            <Text block fontWeight="bold" size="s">
              処方箋をお持ちになって薬局までお越しください。お薬をお渡しします
            </Text>
          </Description>
        </Step>
      </FlowBox>
    </Root>
  );
};
